<template>
  <v-dialog
    :value="dialog"
    :max-width="400"
    persistent
    :retain-focus="false"
    @keydown.esc="escape(closeDialog)"
    @click:outside="escape(closeDialog)"
    @keydown.enter="submit"
  >
    <v-card outlined>
      <v-card-title>
        {{ $t('document.updateDocument') }}
        <p-btn-icon
          type="close"
          btn-class="mr-n3 ml-auto"
          tabindex="4"
          @click="escape(closeDialog)"
        ></p-btn-icon>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-form ref="form" @submit.stop.prevent>
          <v-container>
            <v-row dense align="center" justify="end">
              <v-col>
                <v-text-field
                  type="text"
                  v-model.trim="editedDocument.name"
                  :rules="rules.name"
                  tabindex="1"
                  clearable
                  autofocus
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="justify-center">
        <v-btn tabindex="3" text @click="closeDialog">{{ $t('cancel') }}</v-btn>
        <v-btn :disabled="!isModelChanged()" color="primary" tabindex="2" text @click="submit">{{ $t('save') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import PBtnIcon from '@/components/PBtnIcon'

import snackbarMixin from '@/mixins/snackbar.mixin'
import objectMixin from '@/mixins/object.mixin'
import dialogMixin from '@/mixins/dialog.mixin'
import validationMixin from '@/mixins/validation.mixin'
import unsavedChangesMixin from '@/mixins/unsavedChanges.mixin'

export default {
  components: {
    PBtnIcon
  },


  mixins: [
    snackbarMixin,
    objectMixin,
    dialogMixin,
    validationMixin,
    unsavedChangesMixin
  ],


  props: {
    document: Object
  },


  data () {
    return {
      rule: {
        isUnique: value => !value || !this.documentNames().find(d => d.toLowerCase() === value.toLowerCase()) || value.toLowerCase() === this.document.name.toLowerCase() || this.$t('document.exists')
      },
      editedDocument: {}
    }
  },


  computed: {
    rulesToApply () {
      const rule = this.rule

      return {
        name: [
          rule.required(),
          rule.isUnique
        ]
      }
    }
  },


  methods: {
    ...mapActions('document', ['updateDocument']),
    ...mapGetters('document', ['documentNames']),
    ...mapActions('changes', ['removeFromChanges']),

    onDialogOpen () {
      if (this.document) {
        this.removeFromChanges(this.document)
      }
      this.editedDocument = this.getObjectCopy(this.document)
      this.initWatchedModel(this.editedDocument)
      this.resetValidation()
    },


    async submit () {
      const valid = await this.validate(this.rulesToApply)
      if (!valid || !this.isModelChanged()) return

      try {
        const doc = this.getObjectCopy(this.editedDocument)

        if (document.name !== doc.name) {
          this.showSnackbarProcessing()
          await this.updateDocument(doc)
          this.showSnackbarSuccess(this.$t('document.documentUpdated'))
        }

        this.closeDialog()
      } catch (error) {
        this.showSnackbarError()
        this.$log.error(error)
      }
    }
  }
}
</script>
